module.exports = __webpack_public_path__ + "img/about9.1f3f5f1d.png";